<template>
  <div>
    <div id="table">
      <el-breadcrumb class="breadcrumb" separator="/">
        <el-breadcrumb-item>统计中心</el-breadcrumb-item>
        <el-breadcrumb-item>VCP客服排名</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="screen">
        <el-form ref="form" label-width="68px" label-position="left">
          <div class="flex flex-wrap screen_item">
            <el-form-item
              label="发货时间:"
              style="width: 40%; margin-left: 20px"
            >
              <el-date-picker
                v-model="filter.start"
                type="date"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                style="width: calc(40%)"
              />
              <p style="display: inline-block; width: 40px; text-align: center">
                <span
                  style="
                    display: inline-block;
                    width: 20px;
                    height: 2px;
                    background: #e6e6e6;
                    transform: translateY(-3px);
                  "
                ></span>
              </p>
              <el-date-picker
                v-model="filter.end"
                type="date"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: calc(40%)"
              />
            </el-form-item>

            <!-- <el-form-item label="所属店铺:" style="width: calc(20% - 30px)">
              <el-select
                v-model="filter.store"
                placeholder="所属店铺"
                style="width: 100%"
                clearable
              >
                <el-option label="大明豪京东VCP" :value="0" />
                <el-option
                  v-for="(item, index) in stores"
                  :key="index"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item> -->
            <el-form-item
              label="所属店铺:"
              style="width: calc(25% - 56px); margin-left: 20px"
            >
              <el-select
                v-model="filter.store"
                placeholder="所属店铺"
                style="width: 100%"
                multiple
                clearable
              >
                <el-option
                  v-for="(item, index) in stores"
                  :key="index"
                  :label="item.title"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              label-width="0px"
              style="width: 100%; text-align: center; margin: 0"
            >
              <el-button
                type="primary"
                class="queryBtn"
                :loading="loading"
                @click="handleSearch"
                style="width: 100px"
                >查询</el-button
              >
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="table" :v-loading="loading">
        <statistical :service.sync="service" ref="statistical"></statistical>
      </div>
    </div>
  </div>
</template>
<script>
import statistical from "./Statistical.vue";
import * as echarts from "echarts";
import { payablesExport, search, getStatistic, vcpCustomer } from "@/api";

export default {
  name: "views.customerservice.Index",
  inject: ["handelLoading"],
  components: { statistical },
  data() {
    return {
      service: [],
      binds: true,
      iframe: null,
      drawer: false,
      loading: false,
      region: [],
      brands: [],
      totals: {},
      stores: [
        { id: 0, title: "大明豪京东VCP" },
        { id: 1, title: "大明豪京东VCP-定制中心" },
        { id: 2, title: "扶摇智尚京东VCP" },
        { id: 7, title: "扶摇智尚京东VCP-定制中心" },
      ],
      users: [],
      states: [],
      pd: 0,
      filter: {
        filter: null,
        start: null,
        end: null,
        supplier: null,
        external: null,
        state: null,
        region: null,
      },
      filterss: {
        filter: null,
        start: null,
        end: null,
        supplier: null,
        external: null,
        state: null,
        region: null,
      },
      Order_amount: [],
      Order_quantity: [],
      Order_time: [],
      total: { total: 0, size: 10, current: 1 },
      list: [],
      suppliers: [],
      handleSearcha: false,
      myChartStyle: { float: "left", width: "100%", height: "600px" }, //图表样式
    };
  },
  mounted() {},
  watch: {},
  methods: {
    changeMessage(e) {
      console.log(e);

      if (e.length == 0) {
        this.filter.filter = e;
      }
      this.$forceUpdate();
    },
    changeexternal() {
      this.$forceUpdate();
    },
    handleLoad() {},
    handleLoads() {
      //   getStatistic(this.filter)
      //     .then((response) => {
      //       this.filter.start = response.data.total.start
      //     })
      //     .catch(() => {  });
    },
    handleSearch() {
      this.loading = true;
      this.filter.page = 1;
      this.binds = false;
      this.handleSearcha = "";

      this.$nextTick(() => {
        this.binds = true;
      });
      console.log(this.filter);

      this.homecustomers();
    },
    getstatistics() {
      this.loading = true;
      this.filter.page = 1;
      this.handelLoading(true);
      console.log(this.filter);
      getStatistic(this.filter)
        .then((response) => {
          this.handelLoading((this.loading = false));
          this.filterss = this.filter;
          this.list = response.data.list;

          this.totals = response.data.total;

          if (this.pd == 1) {
            this.filter.start = "";
          } else {
            // this.filter.start = response.data.total.start;
          }

          if (response.data.list.length > 0) {
            this.Order_amount = [];
            this.Order_quantity = [];

            this.Order_time = [];

            response.data.list.map((item) => {
              this.Order_amount.push(item.amount);
              this.Order_quantity.push(item.total);
              this.Order_time.push(item.month);
            });
          } else {
            this.Order_amount = [0, 0, 0, 0, 0, 0, 0, 0];
            this.Order_quantity = [0, 0, 0, 0, 0, 0, 0, 0];
            this.Order_time = [0, 0, 0, 0, 0, 0, 0, 0];
          }
          console.log("213");
          this.initEcharts();
        })
        .catch(() => {
          this.handelLoading((this.loading = false));
        });
    },
    handleLoadBrands() {
      search({ brands: 1, order_stores: 1, users: 1, region: 1 }).then(
        (response) => {
          console.log(response);
          this.brands = response.response.options.brands;
          // this.stores = response.response.options.order_stores;
          this.users = response.response.options.users;
          this.is_vcp = response.response.options.is_vcp;
          console.log(response.response.options.region);
          this.region = response.response.options.region;
        }
      );
    },
    handelCurrentChange(current) {
      this.filter.page = current;
      this.handleLoad();
    },
    handleResetSearch() {
      this.pd = 1;
      this.filter = {
        filter: null,
        start: null,
        end: null,
        supplier: null,
        external: null,
        state: null,
        region: null,
      };
      this.handleSearch();
    },
    handleLoadSuppliers() {
      search({ supplier: 1 })
        .then((response) => {
          this.suppliers = response.response.options.suppliers;
        })
        .catch(() => {});
    },
    handleExport() {
      this.handelMessageBoxConfirm(
        "确定当前检索应付账款吗？",
        (instance, done) => {
          instance.confirmButtonLoading = true;
          payablesExport(this.filter).then((response) => {
            instance.confirmButtonLoading = false;
            if (!response.state) {
              this.$notify.error({ title: "提示", message: response.message });
              return;
            }
            done();

            this.iframe = response.response.url;
          });
        }
      );
    },

    initEcharts() {
      console.log(this.Order_time);
      var Order_time = this.Order_time;
      const option = {
        xAxis: {
          type: "category",

          data: Order_time,
          axisLabel: {
            interval: 0,
            rotate: 30,
          },
          splitLine: {
            show: false,
          },
        },
        legend: {
          data: ["订单金额", "订单数"],
        },
        yAxis: [
          {
            name: "订单金额",
            type: "value",
            boundaryGap: false,
            axisLabel: {
              formatter: "￥{value}",
            },
          },
          {
            name: "订单数",
            type: "value",
            min: 0,

            scale: true,
            boundaryGap: [0.2, 0.2],
            axisLabel: {
              formatter: "{value}个",
            },
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        series: [
          {
            name: "订单金额",
            data: this.Order_amount,
            markPoint: {
              data: [
                { type: "max", name: "Max" },
                { type: "min", name: "Min" },
              ],
            },
            type: "bar",
            // backgroundStyle: {},
          },
          {
            name: "订单数",
            yAxisIndex: 1,
            data: this.Order_quantity,
            type: "line",
          },
        ],
      };

      const myChart = echarts.init(document.getElementById("mychart"));
      myChart.setOption(option);
      //随着屏幕大小调节图表
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },

    homecustomers() {
      console.log(this.filter,'12344');
              this.loading = true;
      this.handelLoading(true);
      vcpCustomer(this.filter)
        .then((response) => {
          this.handelLoading((this.loading = false));
       this.service = response.data;
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.statistical.obtain();
          });
        }, 1000);
        
        })
        .catch(() => {
          this.handelLoading((this.loading = false));
        });
    },
        getCurrentMonthFirst() {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) month = "0" + month;
      if (day < 10) day = "0" + day;
      this.filter.start = date.getFullYear() + "-" + month + "-" + day;
    },
    getCurrentMonthLast() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      var day = new Date(year, month, 0);
      this.filter.end = year + "-" + month + "-" + day.getDate();
    },
  },
  created() {
  
    this.getCurrentMonthFirst()
    this.getCurrentMonthLast()
    this.handleLoad();
    this.handleLoads();

    this.handleLoadBrands();
    // this.getstatistics();
    // // 加载供货商
    // this.handleLoadSuppliers()
      this.homecustomers();
  },
};
</script>
<style lang="scss" scoped>
#table {
  .screen {
    padding: 15px;
    border: 1px solid #e6e6e6;
    border-radius: 10px;
    margin-bottom: 20px;
  }
  .table {
    border: 1px solid #e6e6e6;
    border-radius: 10px;
  }
}
</style>

<style lang="scss">
@import "@/assets/scss/table.scss";
</style>
